'use client';

import { CaseStudyBody } from '@/components/case-study/case-study-body';
import { CaseStudyHero } from '@/components/case-study/case-study-hero';
import { useTranslation } from '@/lib/i18n/context';

/* Thinnest of the set: nothing in Notion, Linear or the O-Brain, and no HubSpot company record under this name. Everything here describes ZenHR's own business, not Open's configuration. CONFIRM EVERY LINE OF THE SOLUTION SECTION BEFORE SHIPPING. No logo asset yet.
 *
 * No stats row and no results table: no cleared figure exists for ZenHR.
 * Add the stats, the table and the six-place number check from the
 * customer-stories skill in the same commit that lands real numbers. */
const ZenHRCaseStudy = () => {
  const { t } = useTranslation();
  return (
    <>
      <CaseStudyHero
        customerName="ZenHR"
        title={t.customerStories['zenhr_hero_title']}
        subtitle={t.customerStories['zenhr_what_we_did']}
      />

      <CaseStudyBody
        aside={{
          logoAlt: 'ZenHR',
          customerName: 'ZenHR',
          company: t.customerStories['zenhr_company_description'],
          industry: t.customerStories['zenhr_industry'],
          websiteUrl: 'https://www.zenhr.com',
          extras: [
            {
              label: t.customerStories.Location,
              value: t.customerStories['zenhr_location'],
            },
          ],
          keyResults: [
            t.customerStories['zenhr_key_result_1'],
            t.customerStories['zenhr_key_result_2'],
            t.customerStories['zenhr_key_result_3'],
            t.customerStories['zenhr_key_result_4'],
          ],
        }}
      >
        <p>{t.customerStories['zenhr_intro']}</p>

        <h2>{t.customerStories['zenhr_challenge_title']}</h2>
        <p>{t.customerStories['zenhr_challenge_p1']}</p>
        <p>{t.customerStories['zenhr_challenge_p2']}</p>
        <p>{t.customerStories['zenhr_challenge_p3']}</p>

        <h2>{t.customerStories['zenhr_solution_title']}</h2>
        <p>{t.customerStories['zenhr_solution_p1']}</p>
        <p>{t.customerStories['zenhr_solution_p2']}</p>
        <p>{t.customerStories['zenhr_solution_p3']}</p>

        <h2>{t.customerStories['zenhr_impact_title']}</h2>
        <p>{t.customerStories['zenhr_impact_p1']}</p>
        <p>{t.customerStories['zenhr_impact_p2']}</p>
      </CaseStudyBody>
    </>
  );
};

export default ZenHRCaseStudy;
